import { formatMoney } from '../../_helpers';

// ─── Format helpers ─────────────────────────────────────────────────────────

export function fmtMoney(value: number, defaultValue: string = '$0.00'): string {
  let result = defaultValue;
  if (value !== null && value !== undefined) {
    result = '$' + formatMoney(value);
  }
  return result;
}

export function fmtCount(value: number, defaultValue: string = '0'): string {
  let result = defaultValue;
  if (value !== null && value !== undefined) {
    result = value.toLocaleString('en-US');
  }
  return result;
}

export function fmtRate(value: number, decimals: number = 2, defaultValue: string = '0.00%'): string {
  let result = defaultValue;
  if (value !== null && value !== undefined) {
    result = value.toFixed(decimals) + '%';
  }
  return result;
}

// ─── Trend helpers ─────────────────────────────────────────────────────────

export function getTrendClass(trendPct: number | null): string {
  let cls = 'trend-positive';
  if (trendPct !== null && trendPct < 0) {
    cls = 'trend-negative';
  } else if (trendPct === 0) {
    cls = 'trend-neutral';
  }
  return cls;
}

export function isTrendNegative(trendPct: number | null): boolean {
  let result = false;
  if (trendPct !== null && trendPct < 0) {
    result = true;
  }
  return result;
}

export function getAbsTrend(trendPct: number | null): string {
  let result = '';
  if (trendPct !== null) {
    result = Math.abs(trendPct).toString();
  }
  return result;
}
